import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import Grid from "@mui/material/Grid";
import {AnagraficaCompleta} from "../../../../widgets/common/AnagraficaCompleta";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {AnagraficaContext, AppContext} from "../../../../../App";
import {AccordionActions, AccordionDetails, Button, Divider, Tooltip, Typography} from "@mui/material";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {
	generateIntervistaIncompleta,
	getIncompletaById,
	setIntervista
} from "../../../../../services/IntervistaServices";
import {useFormContext} from "react-hook-form";
import {IntervistaContext, QuarantenaContext} from "../IntervistaOld";
import {
	valueRegisterNone
} from "../../../../../utils/RegisterUtils";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import CustomText from "../../../../widgets/inputs/CustomText";
import {addAnagrafica} from "../../../../../services/TicketServices";
import {addRelazione, getDiario, searchAnagrafica, setAnagrafica} from "../../../../../services/AnagraficaServices";
import {useParams} from "react-router-dom";
import CustomDateInput from "../../../../widgets/inputs/CustomDateInput";
import SearchPaper from "../../../paziente/utils/SearchPaper";
import {clean} from "../../../../../utils/GenericUtils";
import SearchCardResult from "../../../paziente/utils/SearchCardResult";
import useAnagraficaSearch from "../../../paziente/utils/useAnagraficaSearch";
import {relations} from "../../../../../utils/dictionaries/Generics";
import {CustomAutoComplete} from "../../../../widgets/inputs/CustomAutoComplete";
import {resetAnagrafica} from "../utils/ResetUtils";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import moment from "moment";

const AnagraficaStep = ({tipoPaziente, setStep}) => {
	const classes = BaseStyle();
	const {getValues, errors, trigger, register, watch, control, reset, setValue} = useFormContext();
	const appContext = useContext(AppContext);
	const intervistaContext = useContext(IntervistaContext);
	const anagraficaContext = useContext(AnagraficaContext);
	const quarantenaContext = useContext(QuarantenaContext);
	const [submit, setSubmit] = useState(false);
	const [anagraficaSelected, setAnagraficaSelected] = useState({});
	
	let {idSoggetto, idFocolaio, idIncompleta} = useParams();
	/**
	 * Per la ricerca
	 */
	const [value, setInputValue] = useState("");
	const [open, setOpen] = useState(false);
	const [pageNumber, setPageNumber] = useState(0);
	const {loadingSearch, errorSearch, anagraficheSearch, hasMoreSearch} = useAnagraficaSearch(value, pageNumber);
	const observer = useRef();
	
	const lastTicketElementRef = useCallback(node => {
		if (loadingSearch) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMoreSearch) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loadingSearch, hasMoreSearch])
	
	const handleSearch = (event) => {
		setInputValue(event.target.value);
	}
	
	const onSearch = useCallback(() => {
		if (open) {
			let data = getValues()?.["search"]
			searchAnagrafica(clean(data), anagraficaContext.dispatch);
		}
	}, [getValues, open, anagraficaContext.dispatch])
	
	const onClickDetail = (anagrafica) => {
		setAnagraficaSelected(anagrafica);
		document.getElementById("anagrafica-grid-codf")?.scrollIntoView()
		let value = resetAnagrafica(anagrafica);
		reset(value);
	}
	
	const goForward = useCallback(async () => {
		let result = await trigger([
			("nome"),
			("cognome"),
			("codF"),
			("cell"),
			("email"),
			("domASL"),
			("sesso"),
			("dataNascita"),
			("tipoRelazione"),
		]);
		console.log(errors);
		if (result) {
			setSubmit(true);
			addAnagrafica(getValues(), (id) => {
				getDiario(id, anagraficaContext.dispatch);
				setAnagrafica({
					...getValues(),
					idSoggetto: id
				}, anagraficaContext.dispatch)
				addRelazione(id, idSoggetto, getValues()?.["tipoRelazione"], anagraficaContext.dispatch)
			}).then(() => {
				setIntervista(getValues(), intervistaContext.dispatch)
				setStep(2)
			})
		} else {
			setOpenSnackbar("error", "Controlla bene i dati inseriti!", appContext.dispatch);
		}
	}, [errors, getValues, intervistaContext.dispatch, appContext.dispatch, trigger, anagraficaContext.dispatch, idSoggetto, setStep])
	
	const intervistaIncompleta = useCallback((sendMail, sendSMS) => {
		setSubmit(true)
		generateIntervistaIncompleta({
			nome: watch("nome"),
			cognome: watch("cognome"),
			email: watch("email"),
			cellulare: watch("cell"),
			note: "#" + tipoPaziente + "  " + watch("noteIntervistaIncompleta"),
			idFocolaio: quarantenaContext.state.idFocolaio,
			idAnagraficaPazienteZero: idSoggetto,
			sendMail: sendMail,
			sendSMS: sendSMS,
		}, intervistaContext.dispatch)
	}, [intervistaContext.dispatch, watch, tipoPaziente, quarantenaContext.state.idFocolaio, idSoggetto]);
	
	useEffect(() => {
		if (submit && !intervistaContext.state.loadingAddIntervistaIncompleta && intervistaContext.state.errorAddIntervistaIncompleta === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Intervista incompleta creata con successo!", appContext.dispatch);
			setStep(7);
		} else if (submit && !intervistaContext.state.loadingAddIntervistaIncompleta && intervistaContext.state.errorAddIntervistaIncompleta !== "") {
			setSubmit(false);
			setOpenSnackbar("error", intervistaContext.state.errorAddIntervistaIncompleta, appContext.dispatch);
		}
	}, [submit, intervistaContext.state.loadingAddIntervistaIncompleta, intervistaContext.state.errorAddIntervistaIncompleta, setStep, appContext.dispatch])
	
	useEffect(() => {
		if (idFocolaio) {
			getIncompletaById(idIncompleta, intervistaContext.dispatch);
		}
	}, [idFocolaio, idIncompleta, intervistaContext.dispatch])
	
	useEffect(() => {
		setValue("codF", "");
		setValue("nome", "");
		setValue("cognome", "");
		setValue("dataNascita", null);
		setValue("sesso", "");
	}, [setValue])
	
	return (
		<React.Fragment>
			<AccordionDetails>
				<Grid container spacing={3}>
					
					{idFocolaio && <Grid item xs={12}>
						<Alert severity={"info"} style={{borderRadius: 24}}>
							<AlertTitle><b>Di chi è il diario a fianco?</b></AlertTitle>
							A lato viene mostrato il diario del paziente zero (caso indice), appena inserirai l'anagrafica del
							contatto vedrai aggiornare il diario con quello del "nuovo" paziente
						</Alert>
						{
							intervistaContext.state.loadingGetIncompleta ? <Skeleton/> :
								intervistaContext.state.errorGetIncompleta !== "" ? "Err..." :
									<Alert severity={"info"} style={{borderRadius: 24, marginTop: 10}}>
										<AlertTitle><b>Note indicate dall'intervistatore</b></AlertTitle>
										{intervistaContext.state.incompleta?.note ? intervistaContext.state.incompleta?.note : "Non sono presenti note.."}
									</Alert>
						}
					</Grid>}
					
					<SearchPaper value={value} open={open} onSearch={onSearch} handleSearch={handleSearch}
					             setOpen={setOpen}/>
					
					<Grid item xs={12}>
						<SearchCardResult open={open} onClickDetail={onClickDetail} anagraficheSearch={anagraficheSearch}
						                  errorSearch={errorSearch} loadingSearch={loadingSearch}
						                  lastTicketElementRef={lastTicketElementRef} color={true}/>
					</Grid>
					
					<AnagraficaCompleta classes={classes} intro={"false"} moreInfo={true} anagrafica={anagraficaSelected}/>
					<Grid item xs={12}>
						<CustomAutoComplete
							name={"tipoRelazione"}
							label={"Tipo di relazione *"}
							control={control}
							options={[...Object.keys(relations).sort(), ""]}
							multiple={false}
							rules={{required: true}}
							error={errors["tipoRelazione"]}
						/>
					</Grid>
					{!idFocolaio && <React.Fragment>
						{
							intervistaContext.state.intervista?.["dataInizioIsolamento"] ?
								<Grid item xs={12}>
									<Alert severity="warning" style={{borderRadius: 24, margin: 4}}>
										<AlertTitle><b>Info</b></AlertTitle>
										Il paziente zero (caso indice) <b>ha dichiarato nell'intervista</b> di aver iniziato ad isolarsi dai
										conviventi {moment(intervistaContext.state.intervista?.["dataInizioIsolamento"]).format("DD/MM/YYYY")}
									</Alert>
								</Grid> :
								<Grid item xs={12}>
									<Alert severity="warning" style={{borderRadius: 24, margin: 4}}>
										<AlertTitle><b>Info</b></AlertTitle>
										Il paziente zero (caso indice) non ha dichiarato nell'intervista la data di inizio del'isolamento.
									</Alert>
								</Grid>
						}
					</React.Fragment>}
					<Grid item xs={12} sm={6}>
						<CustomDateInput
							label={"Data ultimo contatto"}
							control={control}
							defaultValue={null}
							maxDate={new Date()}
							rules={{required: false}}
							name={"dataUltimoContatto"}
							error={errors["dataUltimoContatto"]}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<CustomText
							control={control}
							rules={valueRegisterNone}
							label={"Luogo del contatto"}
							autoFocus={false}
							name={"luogoContatto"}
							error={errors["luogoContatto"]}
						/>
					</Grid>
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register(valueRegisterNone)}
							label={"Modalità contatto"}
							autoFocus={false}
							rows={5}
							name={"modalitaContatto"}
							error={errors["modalitaContatto"]}
						/>
					</Grid>
					
					{
						!idFocolaio &&
						<React.Fragment>
							<Grid item xs={12}>
								<Divider/>
							</Grid>
							<Grid item xs={12}>
								<Typography color={"textSecondary"}>
									Nel caso in cui il paziente non risponda al telefono o non possa effettuare l'intervista segnala come
									incompleta, potrai riprenderla più avanti dal pannello "Gestione interviste".<br/>
									Indica solo un nome, cognome, cellulare o email e due note così che ti quando dopo dovrai riprendere
									il
									paziente in mano saprai cosa fare.
								</Typography>
							</Grid>
							
							<Grid item xs={12}>
								<CustomMultiText
									inputRef={register({required: false})}
									label={"Note"}
									autoFocus={false}
									name={"noteIntervistaIncompleta"}
									error={errors["noteIntervistaIncompleta"]}
									rows={5}
								/>
							</Grid>
						</React.Fragment>
					}
				</Grid>
			</AccordionDetails>
			<AccordionActions>
				{
					idFocolaio ?
						<Tooltip title={"Prosegui con il passo successivo"}>
							<Button size={"small"} color={"primary"} variant={"contained"}
							        disableElevation
							        style={{borderRadius: 24}}
							        className={classes.roundButton}
							        onClick={goForward}>
								<b>Prosegui</b>
							</Button>
						</Tooltip>
						:
						<React.Fragment>
							<Tooltip
								title={"Torna al passaggio 7"}>
								<Button size={"small"} className={classes.roundButton} variant={"text"} disableElevation
								        style={{borderRadius: 24}}
								        onClick={() => {
									        setStep(7);
								        }} disabled={submit}>
									<b>Torna indietro</b>
								</Button>
							</Tooltip>
							<Tooltip
								title={"Intervista incompleta: se il paziente non ti risponde ad esempio"}>
								<Button size={"small"} className={classes.roundButton} variant={"contained"} disableElevation
								        color={"secondary"}
								        style={{borderRadius: 24}}
								        onClick={() => intervistaIncompleta(false, false)}>
									<b>Segna incompleta</b>
								</Button>
							</Tooltip>
							<Tooltip title={"Prosegui con il passo successivo"}>
								<Button size={"small"} color={"primary"} variant={"contained"}
								        disableElevation
								        style={{borderRadius: 24}}
								        className={classes.roundButton}
								        onClick={goForward}>
									<b>Prosegui</b>
								</Button>
							</Tooltip>
						</React.Fragment>
				}
			</AccordionActions>
		</React.Fragment>
	);
};

export default React.memo(AnagraficaStep);
